export default __webpack_public_path__ + "static/media/chirho-light.8c6de156.svg";